import { useEffect } from 'react'

import type { TenantData } from 'api/tenants/types'
import type { UserData } from 'api/users/types'

import { ACCOUNT_TYPE_LABEL } from 'components/common/constants'

export const TECHTOUCH_LABEL = {
  ACCOUNT_TYPE: 'db57a233-b635-4814-80ca-e17681bae0b2', // ユーザー権限
  TENANT_ID: '517772b0-5ba0-4645-a08b-d804147dde6b', // テナントID
  TENANT_NAME: '1e272b5f-e163-4e2a-81c0-22a0b37c8979', // テナント名
} as const
export type TechtouchLabelIds = (typeof TECHTOUCH_LABEL)[keyof typeof TECHTOUCH_LABEL]

export const useTechtouch = (tenant: TenantData | undefined, user: UserData) => {
  useEffect(() => {
    if (!window.TechtouchObject || !window.TechtouchAdmin) {
      return
    }
    if (!tenant || !user.userId) {
      window.TechtouchAdmin.customProperty.delete(TECHTOUCH_LABEL.ACCOUNT_TYPE)
      window.TechtouchAdmin.customProperty.delete(TECHTOUCH_LABEL.TENANT_ID)
      window.TechtouchAdmin.customProperty.delete(TECHTOUCH_LABEL.TENANT_NAME)
      return
    }
    // サービス管理者の場合は送らない
    if (user.isServiceManagementRole) {
      return
    }

    window.TechtouchAdmin.customProperty.set(
      TECHTOUCH_LABEL.ACCOUNT_TYPE,
      ACCOUNT_TYPE_LABEL[user.userHasTenants[0].role]
    )
    window.TechtouchAdmin.customProperty.set(TECHTOUCH_LABEL.TENANT_ID, tenant.id.toString())
    window.TechtouchAdmin.customProperty.set(TECHTOUCH_LABEL.TENANT_NAME, tenant.name)
    // startTechtouchは、カスタムプロパティを設定した後、初回のみ呼び出す
    if (window.TechtouchObject.startTechtouch) {
      window.TechtouchObject.startTechtouch()
    }
  }, [tenant, user])
}
